import { InfiniteScrollStore } from 'packages/client/src/app/modules/shared/store/common/infinite-scroll.store';
import { ComponentStoreV2Factory } from '../../../../../modules/shared/store/common/component-store-v2.factory';
import { computed, Injectable } from '@angular/core';
import { accountFrag, currencyFrag } from './organization-settings-journal-dialog.query';

@Injectable()
export class OrganizationSettingJournalDialogStore extends ComponentStoreV2Factory {
    private readonly filter = computed(() => [
        [{
            column: 'organizationId',
            operator: 'EQ',
            value: [String(this.globalGlobalStore.organizationStore.selectedId())],
        }],
    ]);

    public readonly accountScroll = computed(() => new InfiniteScrollStore(
        this.api.getMadoAccounts,
        { filter: this.filter() },
        false,
        accountFrag,
    ));

    public readonly currencyScroll = computed(() => new InfiniteScrollStore(
        this.api.getCurrencies,
        { filter: this.filter() },
        false,
        currencyFrag,
    ));

}
